import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "report-content" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "举报内容",
    modelValue: $setup.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.visible) = $event)),
    "before-close": $setup.handleClose,
    width: "400px"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: $setup.handleCancel }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.handleSubmit,
          disabled: !$setup.canSubmit
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("提交", -1)
          ]))]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: $setup.reportForm,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "举报原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: $setup.reportForm.reason,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.reportForm.reason) = $event)),
                  placeholder: "请选择举报原因",
                  onChange: $setup.handleReasonChange,
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "垃圾广告",
                      value: "垃圾广告"
                    }),
                    _createVNode(_component_el_option, {
                      label: "色情低俗",
                      value: "色情低俗"
                    }),
                    _createVNode(_component_el_option, {
                      label: "政治敏感",
                      value: "政治敏感"
                    }),
                    _createVNode(_component_el_option, {
                      label: "人身攻击",
                      value: "人身攻击"
                    }),
                    _createVNode(_component_el_option, {
                      label: "侵犯隐私",
                      value: "侵犯隐私"
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他",
                      value: "other"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            ($setup.showCustomReason)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "请输入举报原因"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: $setup.reportForm.customReason,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.reportForm.customReason) = $event)),
                      type: "textarea",
                      rows: 4,
                      placeholder: "请输入具体的举报原因",
                      maxlength: "200",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}